<template>
    <div>
        <div class="modal show d-block composer-modal" tabindex="-1" role="dialog" ref="modal">
            <div class="modal-dialog" role="document">
                <form ref="form" class="modal-content" enctype="multipart/form-data" @submit.prevent="handleSubmit">
                    <div class="modal-header">
                        <h5 class="modal-title" v-text="modalTitle"></h5>
                        <button type="button" class="close" @click.prevent="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <composer-edit-logic :row="currentRow" ref="logic"></composer-edit-logic>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="close">Sluiten</button>
                        <button type="submit" class="btn btn-primary" :class="{loading: saving}">Wijzigingen opslaan</button>
                    </div>
                </form>
            </div>
            <div class="modal-backdrop fade show" @click.prevent="close"></div>
        </div>
    </div>
</template>

<script>
    import ComposerEditLogic from "./ComposerEditLogic";
    import { EventBus } from "../../events";
    import  './composer.css'

    export default {
        components: {
            ComposerEditLogic
        },
        props: {
            row: {
                required: true,
                type: Object
            }
        },
        data: function () {
            return {
                currentRow: null,
                saving: false,
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            handleSubmit(event){
                EventBus.$emit('composer-loading', `EditModalSubmit-${this.row.id}`);
                this.saving = true;

                let data = this.$refs.logic.getData();
                data['_method'] = 'PATCH';

                axios.post(`/api/backend/composer/rows/${this.row.id}/`, data)
                .then(response => {
                    this.$emit('update', response.data.data);
                    this.close();
                })
                .catch(error => {
                    this.saving = false;
                })
                .finally(() => {
                    EventBus.$emit('composer-loaded', `EditModalSubmit-${this.row.id}`);
                });
            }
        },
        computed: {
            modalTitle() {
                return _.get(this.row, 'type.name', 'Default Modal Title');
            }
        },
        watch: {},
        mounted() {
        },
        created() {
            this.currentRow = this.row;
        }

    }
</script>
